import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Badge } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/slices/user';
import { selectCartCount } from '../../redux/slices/cart';
import { refreshCartCount } from '../../redux/thunks/cartCount';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const CartButton: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { id: userId } = useAppSelector(selectUser);
    const count = useAppSelector(selectCartCount);

    useEffect(() => {
        dispatch(refreshCartCount(userId));
    }, [dispatch, userId]);

    return (
        <IconButton
            onClick={() => navigate('/cart')}
            aria-label="cart"
            sx={{
                color: 'text.primary',
                '&:hover': { bgcolor: 'profilebutton.hover' },
                width: 40,
                height: 40
            }}
        >
            <Badge
                badgeContent={count}
                color="secondary"
                sx={{
                    '& .MuiBadge-badge': {
                        fontSize: 12,
                        bgcolor: '#FECE00',
                        color: '#fff'
                    }
                }}
            >
                <ShoppingCartIcon sx={{ width: 24, height: 24, color: 'primary.main' }} />
            </Badge>
        </IconButton>
    );
};

export default CartButton;
